import { required } from 'vuelidate/lib/validators'
import {
  licensePlate,
  isLessThanToday,
  isDateAfterYear
} from '~/validations/validations.js'
import Form from '~/utils/mixins/form'

export default {
  mixins: [Form],
  components: {
    RadioBlock: () => import('~/components/commom/radio-block/index'), /// Replace with lib component
    DateBlock: () => import('~/components/commom/date-block/index'), /// Replace with lib component
    ErrorBlock: () => import('~/components/commom/error-block/index'), /// Replace with lib component
    SelectBlock: () => import('~/components/commom/select-block/index'), /// Replace with lib component
    InputBlock: () => import('~/components/commom/input-block/index'), /// Replace with lib component
    ButtonBlock: () => import('~/components/commom/button-block/index')
  },

  data() {
    return {
      carType: '',
      carRegistrationDate: '',
      manufacturer: '',
      model: '',
      version: '',
      licensePlate: '',
      options: {
        carManufactures: [],
        carManufacturesLoading: false,
        carModels: [],
        carModelsLoading: false,
        carVersions: [],
        carVersionsLoading: false
      }
    }
  },

  validations: {
    carType: {
      required
    },
    carRegistrationDate: {
      required,
      isLessThanToday,
      isDateAfterYear: isDateAfterYear(1984)
    },
    manufacturer: {
      required
    },
    model: {
      required
    },
    version: {
      required
    },
    licensePlate: {
      required,
      licensePlate
    }
  },

  computed: {
    vehicleDetails() {
      return {
        carRegistrationDate: this.carRegistrationDate,
        version: this.version,
        licensePlate: this.licensePlate,
        versionLabel: this.getVersionLabel(),
        manufacturerLabel: this.getManufacturerLabel()
      }
    }
  },

  methods: {
    getVersionLabel() {
      const versionId = this.version
      const version = this.options.carVersions.find(
        (item) => item.value === versionId
      )
      return version ? version.name : ''
    },

    getManufacturerLabel() {
      const manufacturerId = this.manufacturer
      const manufacturer = this.options.carManufactures.find(
        (item) => item.value === manufacturerId
      )
      return manufacturer ? manufacturer.name : ''
    },

    focusNextInput(ref) {
      event.preventDefault()
      this.$nextTick(() => {
        const element = this.$refs[ref].$el.querySelector('input')

        if (element === null) {
          return
        }

        element.focus()
      })
    },
    goToNextStep() {
      this.validateForm()

      if (this.$v.$invalid) {
        return
      }
      this.$emit('input', this.vehicleDetails)
    },
    validateForm() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => this.goToFirstError())
      }
    },
    scrollTo(element) {
      const elementPosition =
        element.getBoundingClientRect().top + document.documentElement.scrollTop
      const halfOfViewport =
        Math.max(
          document.documentElement.clientHeight,
          window.innerHeight || 0
        ) / 2

      window.scrollTo(0, elementPosition - halfOfViewport)
    },
    fetchVeiculeDetails(params) {
      return this.$axios.get('/carinsurance/vehicles/', {
        params
      })
    }
  },

  watch: {
    carType() {
      this.manufacturer = null
      this.model = null
      this.version = null
      this.carRegistrationDate = null
      this.options.carModels = []
      this.options.carVersions = []
      this.options.carManufactures = []
    },
    carRegistrationDate(value) {
      if (value === null || this.$v.carRegistrationDate.$invalid) {
        return
      }

      this.manufacturer = null
      this.model = null
      this.version = null
      this.options.carManufactures = []
      this.options.carModels = []
      this.options.carVersions = []

      const params = {
        vehicle_type_id: this.carType,
        type: 'vehiclemake',
        vehicle_date: this.carRegistrationDate
      }

      this.optionscarManufacturesLoading = true
      this.fetchVeiculeDetails(params).then(({ data }) => {
        this.options.carManufactures = data
        this.options.carManufacturesLoading = false
      })
    },
    manufacturer(value) {
      if (value === null || this.$v.manufacturer.$invalid) {
        return
      }
      this.options.carModelsLoading = true

      this.model = null
      this.version = null
      this.options.carVersions = []

      const params = {
        vehicle_type_id: this.carType,
        type: 'vehiclemodel',
        vehicle_date: this.carRegistrationDate,
        vehicle_make_id: this.manufacturer
      }

      this.fetchVeiculeDetails(params).then(({ data }) => {
        this.options.carModels = data
        this.options.carModelsLoading = false
      })
    },

    model(value) {
      if (value === null) {
        return
      }

      this.version = null
      this.options.carVersionsLoading = true

      const params = {
        vehicle_type_id: this.carType,
        type: 'vehicletype',
        vehicle_date: this.carRegistrationDate,
        vehicle_make_id: this.manufacturer,
        vehicle_model_id: this.model
      }

      this.fetchVeiculeDetails(params).then(({ data }) => {
        this.options.carVersionsLoading = false
        this.options.carVersions = data
      })
    }
  }
}
